module.exports = __webpack_public_path__ + "static/media/Badge_LogoLRP.490bbb42.png";